import "./index.scss";
import { debounce } from "@/pages/base/asyncUtils";

const WEBSITE_SUBNAV_CLASS = ".header-nav";
const NAV_FIEXD = "header-nav__fiexd";
const BODY_BACKGROUND = ".body-background";
const WRAPPER = ".wrapper";
const INNERWRAPPER = ".innerwrapper";

$(function () {
    const $subnav = $(WEBSITE_SUBNAV_CLASS);
    const $bodyBackground = $(BODY_BACKGROUND);
    const $wrapper = $(WRAPPER);
    const $innerWrapper = $(INNERWRAPPER);
    function fixNav() {
        if ($bodyBackground.length > 0) {
            $bodyBackground.hide();
        }
        if ($wrapper.length > 0) {
            $wrapper.css("top", 0);
            $wrapper.css("padding-bottom", "28px");
        }
        if ($innerWrapper.length > 0) {
            $innerWrapper.css("top", 0);
            $innerWrapper.css("padding-bottom", "28px");
        }

        if ($subnav.length > 0 && !$subnav.hasClass(NAV_FIEXD)) {
            $subnav.addClass(NAV_FIEXD);
        }
    }
    function unfixNav() {
        if ($bodyBackground.length > 0) {
            $bodyBackground.show();
        }
        if ($wrapper.length > 0) {
            $wrapper.css("top", -59);
        }
        if ($innerWrapper.length > 0) {
            $innerWrapper.css("top", -113);
        }
        if ($subnav.length > 0 && $subnav.hasClass(NAV_FIEXD)) {
            $subnav.removeClass(NAV_FIEXD);
        }
    }
    $(document).on(
        "scroll",
        debounce(10, (e) => {
            const top = $(e.currentTarget).scrollTop();
            if (top > 100) {
                fixNav();
            } else {
                unfixNav();
            }
        }),
    );
});

$(function () {
    function loadTab($el: JQuery, $index: number) {
        $el.addClass("active");
        $el.siblings().removeClass("active");
        const $wrapper = $(WRAPPER);
        const $innerWrapper = $(INNERWRAPPER);
        if ($wrapper.length > 0) {
            $wrapper.css("top", -58);
        }
        if ($innerWrapper.length > 0) {
            $innerWrapper.css("top", -118);
        }
        $(".tab-content").each(function (index, el) {
            if (index === $index) {
                $(el).removeClass("hidden");
            } else {
                $(el).addClass("hidden");
            }
        });
    }

    const hash = location.hash;
    if (hash === "#topicpost") {
        const $el = $(".menu-list .menu-list-item").eq(2);
        loadTab($el, 2);
    }
    $(".menu-list .menu-list-item").click(function () {
        const $el = $(this);
        const $index = $(this).index();
        if ($index < 2 && $(".slick-prev").length) {
            $(".slick-prev").click();
        }
        loadTab($el, $index);
    });
});
